<template>
  <!-- 头部整体盒子 -->
  <div class="header-box">
    <div class="header-two">
      <!-- 导航logo -->
      <div class="header-two-logo">
        <img
          @click="goHome"
          style="cursor: pointer"
          src="@/assets/img/toefl/logo2.png"
        />
      </div>
      <div class="select" :style="{width: selection == 'TOEFL' ? 90 + 'px' : 120 + 'px' }">
        <span>
          {{ $t(selection) }}
          <i class="el-icon-caret-bottom"></i>
        </span>
      </div>
      <ul class="header-two-wrapper" v-if="testReport">
        <template v-if="selection == 'TOEFL'">
          <li v-for="(item, index) in navList[navIndex].children" :key="index">
            <el-popover
              v-if="index > 0 && index != 6"
              placement="bottom"
              width="475"
              trigger="hover"
            >
              <headPopover
                :navindex="index"
                :data="data[index - 1]"
              ></headPopover>
              <el-button slot="reference" type="text" size="16px"
                >{{ item.name }}<i class="el-icon-caret-bottom"></i
              ></el-button>
            </el-popover>
            <div class="search" v-else-if="index == 6" @click="jump(item.path)">
              <span>
                <i class="el-icon-search"></i>
                {{ item.name }}
              </span>
            </div>
            <el-button type="text" v-else @click="jump(item.path)">{{
              item.name
            }}</el-button>
          </li>
        </template>

        <template v-else-if="selection == 'dictationAndReading'">
          <li v-for="(item, index) in navList" :key="index">
            <span @click="jump(item.path)">{{ item.name }}</span>
          </li>
        </template>
      </ul>
    </div>
  </div>
</template>
<script>
import headPopover from "@/components/toefl/dialog/headPopover.vue";

export default {
  name: "headerTwo",
  components: { headPopover },
  data() {
    return {
      // navIndex: this.$store.state.navIndex,
      navIndex: 1,
      testReport: true,
      navList: [...this.list],
    };
  },
  props: {
    list: {
      type: Array,
    },
    selection: {
      type: String,
      default: "dictationAndReading",
    },
  },
  computed: {
    data() {
      return [
        {
          bottom: this.$t("TPO All Free"),
          list: [
            {
              title: this.$t("Exam Mock"),
              img: "icon_dan_lv@2x",
              src: this.$t("Sections Together"),
              width: "24",
              height: "24",
            },
          ],
        },
        {
          bottom: this.$t("Reading Section Free"),
          list: [
            {
              title: this.$t("Section"),
              img: "icon_dan_lv@2x",
              src: this.$t("Articles Get Score"),
              width: "24",
              height: "24",
            },
            {
              title: this.$t("SequentialHome"),
              img: "icon_shun_lv@2x",
              src: this.$t("SingleArticles"),
              width: "24",
              height: "24",
            },
            {
              title: this.$t("TopicExercise"),
              img: "icon_ticai_lv@2x",
              src: this.$t("SingleArticles"),
              width: "24",
              height: "24",
            },
          ],
        },
        {
          bottom: this.$t("No duplication In_Exam with Out_Exam"),
          list: [
            {
              title: this.$t("Section"),
              img: "icon_dan_lv@2x",
              src: this.$t("5 Records Get Score"),
              width: "24",
              height: "24",
            },
            {
              title: this.$t("SequentialHome"),
              img: "icon_shun_lv@2x",
              src: this.$t("Single Record"),
              width: "24",
              height: "24",
            },
            {
              title: this.$t("TopicExercise"),
              img: "icon_ticai_lv@2x",
              src: this.$t("Single Record"),
              width: "24",
              height: "24",
            },
          ],
        },
        {
          bottom: this.$t("No duplication In_Exam with Out_Exam"),
          list: [
            {
              title: this.$t("Section"),
              img: "icon_dan_lv@2x",
              src: this.$t("4 Question"),
              width: "24",
              height: "24",
            },
            {
              title: this.$t("SequentialHome"),
              img: "icon_shun_lv@2x",
              src: this.$t("Single Question"),
              width: "24",
              height: "24",
            },
            {
              title: this.$t("TopicExercise"),
              img: "icon_ticai_lv@2x",
              src: this.$t("Single Question"),
              width: "24",
              height: "24",
            },
          ],
        },
        {
          bottom: this.$t("No duplication In_Exam with Out_Exam"),
          list: [
            {
              title: this.$t("Section"),
              img: "icon_dan_lv@2x",
              src: this.$t("4 Question Writing"),
              width: "24",
              height: "24",
            },
            {
              title: this.$t("SequentialHome"),
              img: "icon_shun_lv@2x",
              src: this.$t("Single Question"),
              width: "24",
              height: "24",
            },
            {
              title: this.$t("TopicExercise"),
              img: "icon_ticai_lv@2x",
              src: this.$t("Single Question"),
              width: "24",
              height: "24",
            },
          ],
        },
      ];
    },
  },
  methods: {
    goHome(){
      this.$router.push('/')
      this.$store.commit('routeName', '/')
    },
    show(obj) {
      alert(obj);
    },
    navClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem("navIndex", index);
      this.menuName = name;
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    },
    jump(pathName) {
      if (this.$route.path != pathName) {
        this.$router.push({ path: pathName });
      }
    },
  },
  created() {},
  watch: {
    "$route.path": {
      handler(newVal, oldName) {
        if (newVal === "/toefl/testReport") {
          this.testReport = false;
        } else {
          this.testReport = true;
        }
      },
      immediate: true, //true就表示会立即执行
    },
  },
  beforeCreate() {},
};
</script>
<style scoped lang="scss">
/* 顶部 */
.header-box {
  width: 100%;
  border-bottom: 1px #e4e2e2 solid;
  background: #fff;
}

/* 导航栏logo */
.header-two {
  width: 1202px;
  overflow: hidden;
  margin: auto;
  height: 80px;
  position: relative;
}

/* 导航栏logo图片 */
.header-two-logo {
  width: 93px;
  height: 27px;
  position: absolute;
  top: 28px;
  left: 0;
  right: 0;
  bottom: 0;
}

.header-two-logo img {
  width: 93px;
  height: 27px;
}

.header-two-wrapper {
  line-height: 40px;
  float: right;
  margin: 0;
  max-width: 950px;
}

/* 导航栏 导航容器
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 40px;
} */

.header-two .header-two-wrapper > li {
  float: left;
  position: relative;
  margin: 0 20px;
  font-size: 16px;
  font-weight: 400;
  color: #7a8da1;
  line-height: 80px;
  cursor: pointer;
}

.header-two .header-two-wrapper > li > a {
  color: #7a8da1;
  position: relative;
}

.header-two .header-two-wrapper > li > i {
  position: absolute;
  width: 0;
  height: 0;
  border: 5px solid transparent;
  border-top-color: #7b8b8e;
  top: 37.5px;
  margin-left: 6px;
}

#header .header-two .header-two-wrapper > li:last-child {
  margin-right: 0;
}

.header-two /deep/ .el-button {
  font-size: 16px !important;
  font-weight: 400 !important;
}

.header-two /deep/ .el-button--text {
  color: #7a8da1 !important;
}

.header-two /deep/ .el-button--text:hover {
  color: green !important;
}

.select {
  min-width: 90px;
  height: 30px;
  background: #fff;
  border: 1px #8eb89c solid;
  border-radius: 30px;
  margin-top: 20px;
  z-index: 99;
  position: absolute;
  top: 5px;
  left: 120px;
  span {
    position: relative;
    top: 4px;
    left: 15px;
    color: #8eb89c;

    i {
      margin-left: 10px;
    }
  }
}

.search {
  width: 110px;
  height: 33px;
  background: #fff;
  border: 1px #e9e9e9 solid;
  border-radius: 17px;
  margin-top: 23px;
  z-index: 99;
  font-size: 16px;

  span {
    position: relative;
    bottom: 24px;
    left: 10px;
    color: #9fa2ac;

    i {
      margin-right: 15px;
    }
  }
}

.search:hover {
  color: #92c1af;
  border: 1px #90d1b9 solid;
  background: #fff;

  span {
    position: relative;

    color: #77b39c;

    i {
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/toefl/common/headerTwo.vue